/* eslint-disable no-param-reassign */
import { DreamEditor } from '../../types';
import { normalizeRoot } from './normalizeRoot';

export const withRoot = (editor: DreamEditor) => {
  editor.normalizeNode = normalizeRoot(editor);

  return editor;
};
